<template>
  <div>
    <v-toolbar
      class="removeBtnPaddingRight"
      color="#DADADA"
      elevation="1"
      flat
    >
      <v-text-field
        single-line
        outlined
        dense
        clearable
        :disabled="isLoading"
        v-model="search.value" label="Поиск" hide-details @keydown.enter="searchData" @click:clear="clearSearchData">
      </v-text-field>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="isLoading"
      :page.sync="pagination.page"
      :items-per-page.sync="pagination.size"
      :server-items-length="count"
      :options.sync="options"
      :footer-props="{'items-per-page-options':[10,50,100]}"
      class="elevation-1 rounded-b-lg"
    >
      <template v-slot:item.information="{ item }">
        <span v-if="item.visitor && item.auto">
          {{item.visitor}} {{item.auto}}
        </span>
        <span v-else-if="item.visitor && !item.auto">
          {{ item.visitor}}
        </span>
        <span v-else>
          {{item.auto}}
        </span>
      </template>
      <template v-slot:item.enter="{item}">
        <span>{{correctTime(item.enter)}}</span>
      </template>
      <template v-slot:item.exit="{item}">
        <span>{{correctTime(item.exit)}}
        <v-tooltip bottom  v-if="item.automate_exit">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="pb-1 medium-primary"
              v-bind="attrs"
              v-on="on"
            >
              hdr_auto
            </v-icon>
          </template>
          <span>Автоматический выход</span>
          </v-tooltip>
        </span>
      </template>
      <template v-slot:no-data>
        <v-btn
          color="primary"
          @click="updateData()"
        >
          Обновить
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>

import {mapActions, mapGetters} from "vuex";
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";
import {displayDate} from "@/helper";

export default {
  name: "EntitledOrdersLogGuardPostList",
  components: {},
  mixins: [PaginatedDataMapperMixin],
  data() {
    return {
      search: {
        parameter: "log"
      },
      headers: [
        {text: "Информация", value: "information", sortable: false, align: "start", width: "50%"},
        {text: "Дата входа", value: "enter", sortable: true, align: "center", width: "25%"},
        {text: "Дата выхода", value: "exit", sortable: true, align: "center", width: "25%"}
      ]
    }
  },
  watch: {
  },
  computed: {
    ...mapGetters({
      items: "entitled/getLogGuardPostList",
      count: "entitled/getLogGuardPostCount",
      isLoading: "entitled/isLoadingLogGuardPost"
    })
  },
  methods: {
    ...mapActions({
      loadLogList: "entitled/loadLogGuardPostList"
    }),
    correctTime (time, minute = true) {
      if(time !==null)
        return displayDate(time, minute)
    },
    updateData(){
      if (this.search.value) {
        this.search.value = ""
      }
      this.loadData()
    },
    loadData(url=undefined){
      this.loadLogList({
        url: url,
        id: this.$route.params.idOrders,
        urlAppend: (url) => {
          return this.addSizeParameter(url);
        },
        finalizer: (data, url) => {
          this.setCurrentLoadUrl(url);
        }
      })
    }
  },
  created() {
    this.loadData(undefined)
  }
}
</script>

<style scoped>
.removeBtnPaddingRight >>> .v-toolbar__content {
  padding-right: 0px;
}
</style>
